import { CardTitle } from "react-migration/components/CardTitle";

export function UtilitySelectionTitle() {
  return <CardTitle>Utility Report</CardTitle>;
}
